import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';

export const selectExportOrdersJobByJobId = (state, { jobId }) => {
  const jobIdToJobMap = get(state, 'jobIdToJobMap', emptyObject);
  return jobIdToJobMap[jobId];
};
